import {
  Environment,
  getEnvironment,
  isPrDeployment,
} from '@backoffice-frontend/environment'
import { Amplify } from 'aws-amplify'

const localCognitoPool = {
  userPoolId: 'eu-central-1_local',
  userPoolClientId: 'local',
  local: true,
  domain: '',
}

type CognitoConfig = {
  userPoolId: string
  userPoolClientId: string
  domain: string
}

const CognitoUserPools: Record<Environment, CognitoConfig> = {
  [Environment.test]: localCognitoPool,
  [Environment.local]: localCognitoPool,
  [Environment.development]: {
    userPoolId: 'eu-central-1_T1pTVaXwM',
    userPoolClientId: '5a3jtd0ekdob0icf1mffp707cj',
    domain: 'moia-backoffice-saml-dev.auth.eu-central-1.amazoncognito.com',
  },
  [Environment.integration]: {
    userPoolId: 'eu-central-1_mLvpihKIx',
    userPoolClientId: '3rusooc4p8ofen1sc6i9m28c8n',
    domain: 'moia-backoffice-saml-int.auth.eu-central-1.amazoncognito.com',
  },
  [Environment.production]: {
    userPoolId: 'eu-central-1_6dXtfMPQv',
    userPoolClientId: '303i548r0d7rd5q2b2s9a178hj',
    domain: 'moia-backoffice-saml-prd.auth.eu-central-1.amazoncognito.com',
  },
}

const PR_LOGIN_REDIRECT = 'https://pr.backoffice.int.moia-group.io/login/'

const getSignInRedirect = () => {
  if (isPrDeployment) {
    return PR_LOGIN_REDIRECT
  }

  const { host, protocol } = window.location
  return `${protocol}//${host}/login/`
}

export const configureAmplify = (userPoolClientId: string): void => {
  const { userPoolId, domain } = CognitoUserPools[getEnvironment()]

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        loginWith: {
          oauth: {
            domain,
            scopes: ['email', 'openid', 'aws.cognito.signin.user.admin'],
            redirectSignIn: [getSignInRedirect()],
            redirectSignOut: [],
            responseType: 'code',
          },
        },
      },
    },
  })
}
